import React from 'react';
import IMG1 from '../../assets/finance-ledger.png';
import IMG2 from '../../assets/goit-react-hw-05-movies.png';
// import IMG3 from '../../assets/slimmom-calculate-daily-calorie-front.png';
// import IMG4 from '../../assets/slimmom-calculate-daily-calorie-back.png';
import IMG5 from '../../assets/3dfreedom.png';
import IMG6 from '../../assets/Filmoteka.png';
import IMG7 from '../../assets/image-finder.png';
import IMG8 from '../../assets/image-finder-JS.png';
import IMG9 from '../../assets/WebStudio.png';
import IMG10 from '../../assets/dream-beats.png';
import IMG11 from '../../assets/coffee.png';
import IMG12 from '../../assets/skillryzen-testplatform.png';
import IMG13 from '../../assets/smiledent.png';
// import IMG14 from '../../assets/bookstore.png';

import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [
    // {
    //   id: 1,
    //   title: 'Book Store',
    //   img: IMG14,
    //   description: 'A book App, with a user account. REST API USER. ',
    //   technologies: 'React | SCSS',
    //   link: 'https://softryzen-internship.github.io/bookstore/',
    //   github: 'https://github.com/SoftRyzen-internship/bookstore',
    // },
    {
      id: 2,
      title: 'Smile Dent',
      img: IMG13,
      description:
        'Langing Page, the layout is fixed in px. The layout is semantic (HTML5) and valid, with accessibility (а11у). The gulp compiler was used for the build. ',
      technologies: 'HTML | CSS | GULP',
      link: 'https://softryzen-internship.github.io/smile-dent/',
      github: 'https://github.com/SoftRyzen-internship/smile-dent/',
    },
    {
      id: 3,
      title: 'Skillryzen Test Board',
      img: IMG12,
      description: 'LMS A platform for testing students, with a user account',
      technologies: 'React | TS | Webpack',
      link: 'https://skillryzen.netlify.app/',
      github: 'https://github.com/SoftRyzen-internship/skillryzen/',
    },
    {
      id: 4,
      title: 'Coffee',
      img: IMG11,
      description:
        'Langing Page, the layout is fixed in px. The layout is semantic (HTML5) and valid, with accessibility (а11у). The gulp compiler was used for the build. ',
      technologies: 'HTML | CSS | GULP',
      link: 'https://softryzen-internship.github.io/coffee/',
      github: 'https://github.com/SoftRyzen-internship/coffee/',
    },
    {
      id: 5,
      title: 'Dream Beats',
      img: IMG10,
      description:
        'Langing Page, the layout is fixed in px. The layout is semantic (HTML5) and valid, with accessibility (а11у). The gulp compiler was used for the build. ',
      technologies: 'HTML | CSS | GULP',
      link: 'https://softryzen-internship.github.io/headphones/',
      github: 'https://github.com/SoftRyzen-internship/headphones/',
    },
    {
      id: 6,
      title: 'Finance Ledger',
      img: IMG1,
      description:
        'Langing Page, the layout is fixed in px. The layout is semantic (HTML5) and valid, with accessibility (а11у). The gulp compiler was used for the build. ',
      technologies: 'HTML | CSS | GULP',
      link: 'https://finance-ledger-2023.netlify.app/',
      github: 'https://github.com/Kretsul-Vitaliy/finance-ledger-2023-gulp/',
    },
    {
      id: 7,
      title: 'Movie search',
      img: IMG2,
      description:
        'Movie search app on the service (themoviedb)  that allows users to learn more about a movie or cast',
      technologies: 'React | React-DOM',
      link: 'https://kretsul-vitaliy.github.io/goit-react-hw-05-movies/',
      github: 'https://github.com/Kretsul-Vitaliy/goit-react-hw-05-movies',
    },
    // {
    //   id: 8,
    //   title: 'Daily Calorie Front-end',
    //   img: IMG3,
    //   description:
    //     'Front-end with information with information how much you eat matters more than what you eat when it comes to losing weight or building muscles.',
    //   technologies: 'React | Redux | NodeJS | MongoDB',
    //   link: 'https://calories-slim.netlify.app/',
    //   github:
    //     'https://github.com/Kretsul-Vitaliy/slim-mom-calculate-daily-calorie-frontend',
    // },
    // {
    //   id: 9,
    //   title: 'Daily Calorie Back-end',
    //   img: IMG4,
    //   description:
    //     'Back-end (NodeJs | MongoDB) with information how much you eat matters more than what you eat when it comes to losing weight or building muscles.',
    //   technologies: 'NodeJS | MongoDB | Swagger',
    //   link: 'https://slim-calories.onrender.com/api-docs/',
    //   github:
    //     'https://github.com/Kretsul-Vitaliy/slim-mom-calculate-daily-calorie-backend',
    // },
    {
      id: 10,
      title: '3DFreedom',
      img: IMG5,
      description:
        'Team project of a mobile responsive multi-page website for a 3D modeling company. With the help of this site, the client can place an order or view a gallery of samples and the companys capabilities.',
      technologies: 'HTML5 | SASS | JavaScript',
      link: 'https://kretsul-vitaliy.github.io/parcel-3dfreedom-group-11/',
      github: 'https://github.com/Kretsul-Vitaliy/parcel-3dfreedom-group-11',
    },
    {
      id: 11,
      title: 'Filmoteka',
      img: IMG6,
      description:
        'Website with information about popular films, beautiful design and with the ability to search and save you favorite movies.',
      technologies: 'HTML5 | SASS | JavaScript',
      link: 'https://kuzia30.github.io/team-project-js/',
      github: 'https://github.com/Kuzia30/team-project-js',
    },
    {
      id: 12,
      title: 'Image-finder',
      img: IMG7,
      description: 'Website with search Image app on the service (Pixabay).',
      technologies: 'React',
      link: 'https://kretsul-vitaliy.github.io/goit-react-hw-04-hooks-images/',
      github:
        'https://github.com/Kretsul-Vitaliy/goit-react-hw-04-hooks-images',
    },
    {
      id: 13,
      title: 'Image-finderJS',
      img: IMG8,
      description: 'Website with search Image app on the service (Pixabay).',
      technologies: 'HTML5 | SASS | JavaScript',
      link: 'https://kretsul-vitaliy.github.io/goit-js-hw-11/',
      github: 'https://github.com/Kretsul-Vitaliy/goit-js-hw-11',
    },
    {
      id: 14,
      title: 'WebStudio',
      img: IMG9,
      description:
        'Website with ordering services for effective business development.',
      technologies: 'HTML5 | SASS | CSS3 | JavaScript',
      link: 'https://kretsul-vitaliy.github.io/goit-markup-hw-08/',
      github: 'https://github.com/Kretsul-Vitaliy/goit-markup-hw-08',
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
